<template>
    <g-bottom-drawer
        :visible="$root.isShowRcDownloadDrawer"
        :height="drawerHeight"
        @coverClick="closeDrawer"
    >
        <div class="download-recommend-drawer">
            <div class="head-game-info" :style="{backgroundImage: 'url(' + rcDownloadBg + ')'}">
                <img :src="titleIcon" class="head-title">
                <img
                    :src="closeIcon" class="close-icon"
                    @click="closeDrawer"
                >
                <div>
                    <img :src="gameIcon" class="game-icon">
                </div>
                <div class="game-name">{{ gameName }}</div>
                <div class="game-capacity">{{ gameCapacity }}</div>
            </div>
            <div class="recommend-drawer-bottom">
                <tiebaPannel
                    :rc-drawer-info="rcDrawerInfo"
                />
            </div>
        </div>
    </g-bottom-drawer>
</template>

<script>
import GBottomDrawer from '@/composition-components/GBottomDrawer.vue';
import downloadShopCloseIcon from 'public/assets/imgs/download-shop-close-icon.png';
import titleIcon from 'public/assets/imgs/rec-download-drawer-title.png';
import tiebaPannel from './app-detail-download-rc-pannel.vue';
export default {
    components: {
        GBottomDrawer,
        tiebaPannel,
    },
    props: {
        gameName: {
            type: String,
            default: '',
        },
        gameCapacity: {
            type: String,
            default: '',
        },
        gameIcon: {
            type: String,
            default: '',
        },
        tiebaInfo: {
            type: Object,
            default: () => {},
        },
        rcDrawerInfo: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        isShowRcDrawer() {
            return this.$root.isShowRcDownloadDrawer;
        },
        drawerHeight() {
            if (this.rcDrawerInfo.tieba_threads.length === 0 && this.rcDrawerInfo.is_show_four_element === 0) {
                return 1130;
            }
            return this.rcDrawerInfo.tieba_threads.length > 0 && this.rcDrawerInfo.is_show_four_element === 1
                ? 1363 : this.rcDrawerInfo.is_show_four_element === 1 ? 1228 : 1258;
        },
    },
    data() {
        return {
            closeIcon: downloadShopCloseIcon,
            titleIcon: titleIcon,
            rcDownloadBg: 'https://gamedelivery.cdn.bcebos.com/comment/537e2da2038776951074a1c250edaa2b.png',
        };
    },
    watch: {
        isShowRcDrawer(val) {
            if (val) {
                this.$root.sendLog('display', 'Recommendedlayerdisplay');
            }
        },
    },
    methods: {
        closeDrawer() {
            this.$root.isShowRcDownloadDrawer = false;
            this.$root.sendLog('click', 'CloseBtnClick');
        },
    },
};
</script>

<style lang="scss" scoped>
.download-recommend-drawer {
    width: 100%;
    height: 100%;
    border-radius: 36px;
    .head-game-info {
        padding: 72px 0;
        box-sizing: border-box;
        width: 1242px;
        position: relative;
        text-align: center;
        background-size: 100% 100%;
        .head-title {
            width: 662px;
            height: 51px;
            margin-bottom: 60px;
        }
        .close-icon {
            width: 35px;
            height: 35px;
            position: absolute;
            top: 80px;
            right: 51px;
        }
        .game-icon {
            border: 1px solid rgba(0,0,0,0.1);
            border-radius: 54px;
            width: 230px;
            height: 230px;
        }
        .game-name {
            font-family: PingFangSC-Medium;
            font-size: 48px;
            color: #222222;
            line-height: 48px;
            font-weight: 500;
            margin: 12px 0 18px 0;
        }
        .game-capacity {
            font-family: PingFangSC-Medium;
            font-size: 36px;
            color: #CCCCCC;
            line-height: 36px;
            font-weight: 500;
        }
    }
    .recommend-drawer-bottom {
        padding: 0 51px 51px 51px;
        box-sizing: border-box;
    }
}
</style>